import { communityPosts } from '@/mocks/sportsData';

export default function CommunitySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            互动社区
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            与千万体育迷一起讨论赛事，分享观点，感受体育带来的激情与快乐
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {communityPosts.map((post) => (
            <div
              key={post.id}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-sm font-semibold text-primary-600">
                    {post.user.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{post.user}</p>
                  <p className="text-xs text-foreground-500">{post.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed line-clamp-4">
                {post.content}
              </p>
              <div className="flex items-center gap-4 mt-4 pt-4 border-t border-background-200/70">
                <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  <i className="ri-heart-line"></i> {post.likes.toLocaleString()}
                </button>
                <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                  <i className="ri-chat-1-line"></i> {post.comments.toLocaleString()}
                </button>
                <button className="flex items-center gap-1.5 text-xs text-foreground-500 hover:text-primary-600 transition-colors duration-200 ml-auto cursor-pointer">
                  <i className="ri-share-forward-line"></i> 分享
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer">
            加入社区讨论
          </button>
        </div>
      </div>
    </section>
  );
}